import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Range } from 'rc-slider';
import { Button } from 'react-bootstrap';
import { find, findLast, indexOf, last, first } from 'lodash';
import MoneyDisplay from '../money-display';
import NumberDisplay from '../number-display';
import styles from './styles.css';
import Modal from './modal';
class DoubleSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.onSliderChange = this.onSliderChange.bind(this);
    this.handleManualBoundChange = this.handleManualBoundChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }


  onSliderChange(bounds) {
    this.props.onSliderChange(bounds);
  }

  handleManualBoundChange(min, max) {
    const { values } = this.props;
    if (values) {
      const s = first(values);
      const b = last(values);
      const lower = min <= s ? s : findLast(values, v => v <= min);
      const upper = max >= b ? b : find(values, v => v >= max);
      const lowerIndex = indexOf(values, lower);
      const upperIndex = indexOf(values, upper);
      if (lowerIndex >= 0 && upperIndex >= 0) {
        this.props.onSliderChange([lowerIndex, upperIndex]);
      }
    } else {
      this.props.onSliderChange([min, max]);
    }
  }

  openModal() {
    this.setState({ show: true });
    this.props.onModalToggle(true);
  }
  closeModal() {
    this.setState({ show: false });
    this.props.onModalToggle(false);
  }

  render() {
    const {
      bounds, values, isMoney, displayProps, modalProps, disabled,
      bsStyle,
    } = this.props;
    const { show } = this.state;
    
    let lowerBound = bounds[0] !== undefined ? bounds[0] : null;
    let upperBound = bounds[1] !== undefined ? bounds[1] : null;
    if (values) {
      lowerBound = values[bounds[0]] !== undefined ? values[bounds[0]] : null;
      upperBound = values[bounds[1]] !== undefined ? values[bounds[1]] : null;
    }

    const DisplayComp = isMoney ? MoneyDisplay : NumberDisplay;
    const displayCompProps = {
      precision: isMoney ? 1 : 0,
      ...displayProps,
    };

    const labelComp = (
      <span>from <DisplayComp value={lowerBound} abbreviated {...displayCompProps} /> to <DisplayComp value={upperBound} abbreviated {...displayCompProps} /></span>
    );

    return (
      <span className="dropdown btn-group open">
        <Modal
          {...modalProps}
          show={(show && !disabled)}
          lowerBound={lowerBound || 0}
          upperBound={upperBound || 0}
          onBoundChange={this.handleManualBoundChange}
          onClose={this.closeModal}
        />

        <Button
          bsSize="sm"
          bsStyle={(bsStyle || 'link')}
          onClick={this.openModal}
          disabled={disabled}
        >
          {labelComp}
        </Button>
      </span>
    );
  }
}


DoubleSlider.propTypes = {
  onSliderChange: PropTypes.func,
  bounds: PropTypes.arrayOf(PropTypes.number), // select values [lower, upper]
  values: PropTypes.arrayOf(PropTypes.number), // all possible values
  increase: PropTypes.func,
  decrease: PropTypes.func,
  isMoney: PropTypes.bool,
  displayProps: PropTypes.shape({}),
  modalProps: PropTypes.shape({}),
  onModalToggle: PropTypes.func,
  disabled: PropTypes.bool,
  bsStyle: PropTypes.string,
};
DoubleSlider.defaultProps = {
  onSliderChange: () => {},
  displayProps: {},
  modalProps: {},
  bounds: [0, 0],
  values: null,
  isMoney: true,
  increase: () => {},
  decrease: () => {},
  onModalToggle: () => {},
  disabled: false,
  bsStyle: null,
};

export default DoubleSlider;
